module.exports = __webpack_public_path__ + "img/entry-appointment.e08d20c4.svg";